/* HUMDRUM v4 — site behavior
   No dependencies. Every interaction degrades gracefully without JS. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mobile drawer -------------------------------------------------------- */
  var drawer = document.getElementById('drawer');
  var burger = document.getElementById('burger');
  var lastFocus = null;

  function setDrawer(open) {
    if (!drawer) return;
    drawer.dataset.open = String(open);
    drawer.setAttribute('aria-hidden', String(!open));
    if (burger) burger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      lastFocus = document.activeElement;
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }

  if (burger) burger.addEventListener('click', function () {
    setDrawer(drawer.dataset.open !== 'true');
  });
  var drawerClose = document.getElementById('drawer-close');
  if (drawerClose) drawerClose.addEventListener('click', function () { setDrawer(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.dataset.open === 'true') setDrawer(false);
  });
  // Keep focus inside the open drawer
  if (drawer) drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var items = drawer.querySelectorAll('a[href], button:not([disabled])');
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* Rotating announcement ------------------------------------------------ */
  var ann = document.querySelector('.announce[data-rotate]');
  if (ann) {
    var slots = ann.querySelectorAll('.announce__item');
    var at = 0;
    if (slots.length > 1) setInterval(function () {
      if (ann.matches(':hover')) return;
      slots[at].dataset.active = 'false';
      at = (at + 1) % slots.length;
      slots[at].dataset.active = 'true';
    }, 5200);
  }

  /* Bundle tiles: drag the divider to see more of either chew ----------- */
  document.querySelectorAll('.pair').forEach(function (pair) {
    var grip = pair.querySelector('.pair__handle');
    if (!grip) return;
    var set = function (pct) {
      pct = Math.max(15, Math.min(85, pct));
      pair.style.setProperty('--x', pct + '%');
      grip.setAttribute('aria-valuenow', String(Math.round(pct)));
    };
    var pct = function (e) { var r = pair.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; };
    grip.addEventListener('pointerdown', function (e) { e.preventDefault(); grip.setPointerCapture(e.pointerId); pair.dataset.dragging = 'true'; });
    grip.addEventListener('pointermove', function (e) { if (pair.dataset.dragging === 'true') set(pct(e)); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      grip.addEventListener(t, function () { pair.dataset.dragging = 'false'; });
    });
    grip.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    grip.addEventListener('keydown', function (e) {
      var v = parseFloat(pair.style.getPropertyValue('--x')) || 50;
      if (e.key === 'ArrowLeft') { set(v - 5); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(v + 5); e.preventDefault(); }
    });
  });

  /* Swipe rails: pillars, the six and the pairs each become one still screen
     you swipe through on a phone. The rail itself is CSS scroll-snap; this
     only adds the dots, which are both the position readout and a way to
     jump. Above the breakpoint the rail is `display: contents` and the dots
     are hidden, so none of this touches the desktop layout. ------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-rail]'), function (rail) {
    var items = Array.prototype.slice.call(rail.children);
    if (items.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'm-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Choose one');
    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'm-dot';
      b.setAttribute('aria-label', 'Show ' + (i + 1) + ' of ' + items.length);
      b.addEventListener('click', function () {
        rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });
    rail.parentNode.insertBefore(dots, rail.nextSibling);

    var marks = dots.children, current = -1;
    var sync = function () {
      var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bestD = Infinity;
      items.forEach(function (item, i) {
        var c = item.offsetLeft - rail.offsetLeft + item.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      if (best === current) return;
      current = best;
      for (var i = 0; i < marks.length; i++) marks[i].setAttribute('aria-current', i === best ? 'true' : 'false');
    };
    var queued = false;
    rail.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    }, { passive: true });
    sync();
  });

  /* Autoplaying video: hold the source back until the video is nearly in
     view, then play in view and pause out of it.

     The autoplay attribute overrides preload="metadata", so without this
     every video on a page is fetched the moment it loads — on About that
     was five files downloading at once before the visitor had scrolled. */
  var vids = document.querySelectorAll('video[autoplay]');
  if (vids.length && 'IntersectionObserver' in window) {
    var detach = function (v) {                 // src may be on the element
      var u = v.getAttribute('src');            // or on <source> children
      if (u) { v.setAttribute('data-src', u); v.removeAttribute('src'); }
      Array.prototype.forEach.call(v.querySelectorAll('source'), function (s) {
        var su = s.getAttribute('src');
        if (su) { s.setAttribute('data-src', su); s.removeAttribute('src'); }
      });
      v.load();                                 // abort whatever the parser queued
    };
    Array.prototype.forEach.call(vids, detach);
    var attach = function (v) {
      if (v.dataset.loaded) return;
      v.dataset.loaded = '1';
      if (v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src'));
      Array.prototype.forEach.call(v.querySelectorAll('source[data-src]'), function (s) {
        s.setAttribute('src', s.getAttribute('data-src'));
      });
      v.load();
    };
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { attach(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { rootMargin: '400px 0px' });
    Array.prototype.forEach.call(vids, function (v) { vio.observe(v); });
  }

  /* Scroll stages: the scroll position drives each pinned section --------- */
  var clamp01 = function (v) { return Math.max(0, Math.min(1, v)); };
  var backOut = function (t) { var c = 1.70158; t = t - 1; return t * t * ((c + 1) * t + c) + 1; };
  Array.prototype.forEach.call(document.querySelectorAll('.ps-scrub'), function (scrub) {
    var stage = scrub.querySelector('.ps-stage');
    var lex = scrub.querySelector('.ps-lex .lexicon');
    var layers = Array.prototype.slice.call(scrub.querySelectorAll('.ps-layer'));
    var fill = scrub.querySelector('.ps-rail__fill');
    var strokes = layers.map(function (l) { return l.querySelectorAll('svg path, svg rect, svg circle:not([fill])'); });
    var n = layers.length, lastY = null;
    var update = function () {
      var rect = scrub.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = scrub.offsetHeight - vh;
      var prog = clamp01(-rect.top / total);
      stage.dataset.live = String(rect.top < vh * 0.85);
      stage.dataset.progressStarted = String(prog > 0.02);
      if (lex && !reduced) lex.style.transform = 'scale(' + (0.94 + 0.06 * prog).toFixed(3) + ')';
      var idx = Math.min(n - 1, Math.floor(prog * n));
      var within = prog * n - idx;
      stage.dataset.final = String(idx === n - 1);
      layers.forEach(function (l, i) {
        var on = i === idx;
        l.dataset.active = String(on);
        l.setAttribute('aria-hidden', String(!on));
        if (!on) { l.style.opacity = '0'; return; }
        var media = l.querySelector('.cs__media'), pouch = l.querySelector('.cs__pouch'), jar = l.querySelector('.cs__jar');
        if (reduced) {
          l.style.opacity = '1'; l.style.transform = 'none';
          strokes[i].forEach(function (s) { s.style.strokeDashoffset = '0'; });
          if (jar) { jar.style.opacity = '1'; pouch.style.opacity = '0'; }
          return;
        }
        // The first pillar is there the moment the stage pins; every next one
        // pops in over the last. Nothing ever fades to an empty frame.
        var enter = i === 0 ? 1 : clamp01(within / 0.12);
        var draw = i === 0 ? clamp01((prog * n + 0.35) / 0.5) : clamp01((within - 0.02) / 0.45);
        var scale = 0.82 + 0.18 * backOut(enter);
        l.style.opacity = enter.toFixed(3);
        l.style.transform = 'translateY(' + (((1 - enter) * 44) - within * 26).toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
        strokes[i].forEach(function (s) { s.style.strokeDashoffset = (700 * (1 - draw)).toFixed(0); });
        var svg = l.querySelector('svg');
        if (svg) svg.style.transform = 'translateY(' + ((0.5 - within) * 40).toFixed(1) + 'px) rotate(' + ((within - 0.5) * 4).toFixed(2) + 'deg)';
        var minis = l.querySelectorAll('.mini');
        if (minis.length) minis.forEach(function (mi, k) {
          var e = clamp01((within - 0.03 - k * 0.07) / 0.12);
          mi.style.opacity = e.toFixed(3);
          mi.style.transform = 'translateY(' + ((1 - e) * 34).toFixed(1) + 'px) scale(' + (0.84 + 0.16 * backOut(e)).toFixed(3) + ')';
        });
        if (media) media.style.transform = 'translateY(' + ((0.5 - within) * 36).toFixed(1) + 'px) rotate(' + ((within - 0.5) * 2).toFixed(2) + 'deg)';
        if (jar) { var x = clamp01((within - 0.42) / 0.22); jar.style.opacity = x.toFixed(3); pouch.style.opacity = (1 - x).toFixed(3); }
      });
      if (fill) fill.style.width = (prog * 100).toFixed(1) + '%';
    };
    var onScroll = function () { if (window.scrollY !== lastY) { lastY = window.scrollY; update(); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Product spreads: as each passes the middle, the pouch becomes its jar and
     the photograph eases sideways — the conversation carried by the scroll ---- */
  var spreads = Array.prototype.slice.call(document.querySelectorAll('.spread'));
  if (spreads.length && !reduced) {
    var lastSY = null;
    var tick = function () {
      var vh = window.innerHeight;
      spreads.forEach(function (sp) {
        var r = sp.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) return;
        var t = clamp01((vh - r.top) / (vh + r.height));      // 0 entering from below, 1 gone above
        var c = (t - 0.5) * 2;                                // -1 .. 1, 0 when centred
        var md = sp.querySelector('.spread__media'), body = sp.querySelector('.spread__body');
        var x = clamp01((t - 0.36) / 0.2);
        Array.prototype.forEach.call(md.querySelectorAll('.cs__jar'), function (im) { im.style.opacity = x.toFixed(3); });
        Array.prototype.forEach.call(md.querySelectorAll('.cs__pouch'), function (im) { im.style.opacity = (1 - x).toFixed(3); });
        var ease = c * Math.abs(c);                           // gentle near the centre, decisive at the edges
        md.style.transform = 'translate(' + (-ease * 14).toFixed(2) + '%, ' + (-ease * 24).toFixed(1) + 'px) rotate(' + (-ease * 2.5).toFixed(2) + 'deg)';
        body.style.transform = 'translateY(' + (-ease * 40).toFixed(1) + 'px)';
        body.style.opacity = (1 - Math.max(0, Math.abs(c) - 0.6) / 0.4).toFixed(3);
      });
    };
    window.addEventListener('scroll', function () { if (window.scrollY !== lastSY) { lastSY = window.scrollY; tick(); } }, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  /* Big collection cards: pouch becomes its jar as the card passes the middle -- */
  var bigTiles = Array.prototype.slice.call(document.querySelectorAll('.grid--big .card__media--swap'));
  if (bigTiles.length && !reduced) {
    var lastBY = null;
    var tickBig = function () {
      var vh = window.innerHeight;
      bigTiles.forEach(function (tile) {
        var r = tile.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var mid = (r.top + r.height / 2) / vh;                 // 1 at the bottom edge, 0 at the top
        var x = clamp01((0.62 - mid) / 0.22);                  // dissolve as the card's middle crosses ~60% of the screen
        var imgs = tile.querySelectorAll('img');
        imgs[0].style.opacity = (1 - x).toFixed(3);
        imgs[1].style.opacity = x.toFixed(3);
        tile.style.transform = 'translateY(' + ((mid - 0.5) * 18).toFixed(1) + 'px)';
      });
    };
    window.addEventListener('scroll', function () { if (window.scrollY !== lastBY) { lastBY = window.scrollY; tickBig(); } }, { passive: true });
    window.addEventListener('resize', tickBig);
    tickBig();
  }

  /* The six, as a conversation: hold, glide, hold — driven by scroll -------- */
  var flow = document.querySelector('.cs-flow');
  if (flow) {
    var fStage = flow.querySelector('.ps-stage');
    var fLayers = Array.prototype.slice.call(flow.querySelectorAll('.ps-layer'));
    var fFill = flow.querySelector('.ps-rail__fill');
    var fn = fLayers.length, fLast = null;
    var smooth = function (t) { t = clamp01(t); return t * t * (3 - 2 * t); };
    var fUpdate = function () {
      var rect = flow.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = flow.offsetHeight - vh;
      var prog = clamp01(-rect.top / total);
      fStage.dataset.live = String(rect.top < vh * 0.85);
      var P = prog * (fn - 0.5);                       // 0 .. n-0.5, so the last chew gets its hold too
      var k = Math.min(fn - 1, Math.floor(P));
      var u = P - k;                                   // where we are between chew k and k+1
      var glide = smooth((u - 0.38) / 0.28);           // hold 38%, glide 28%, hold 34%
      var E = k + glide;                               // effective position
      fLayers.forEach(function (l, i) {
        var d = i - E;                                 // +1 waiting to the right, 0 centred, -1 gone to the left
        var a = Math.max(0, 1 - Math.abs(d));
        var on = a > 0.001;
        l.setAttribute('aria-hidden', String(!(i === k && glide < 0.5 || i === k + 1 && glide >= 0.5)));
        l.dataset.active = String(on);
        if (!on) { l.style.opacity = '0'; return; }
        var media = l.querySelector('.cs__media'), body = l.querySelector('.cs__body');
        var pouch = l.querySelector('.cs__pouch'), jar = l.querySelector('.cs__jar');
        l.style.opacity = reduced ? '1' : a.toFixed(3);
        if (reduced) { l.style.transform = 'none'; media.style.transform = 'none'; body.style.transform = 'none'; jar.style.opacity = '1'; pouch.style.opacity = '0'; return; }
        media.style.transform = 'translateX(' + (d * 46).toFixed(2) + '%) rotate(' + (d * 3).toFixed(2) + 'deg)';
        body.style.transform = 'translateY(' + (d * 70).toFixed(1) + 'px)';
        var x = i === k ? clamp01((u - 0.06) / 0.24) : (i < k ? 1 : 0);   // dissolve to the jar during the hold
        if (jar && pouch) { jar.style.opacity = x.toFixed(3); pouch.style.opacity = (1 - x).toFixed(3); }
      });
      if (fFill) fFill.style.width = (prog * 100).toFixed(1) + '%';
    };
    window.addEventListener('scroll', function () { if (window.scrollY !== fLast) { fLast = window.scrollY; fUpdate(); } }, { passive: true });
    window.addEventListener('resize', fUpdate);
    fUpdate();
  }

  /* Accordions ----------------------------------------------------------- */
  document.querySelectorAll('.acc__trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.dataset.open = String(!open);
    });
  });

  /* A link straight to one question opens it ---------------------------- */
  var openHashItem = function () {
    var id = location.hash.slice(1); if (!id) return;
    var item = document.getElementById(id);
    if (!item || !item.classList.contains('acc__item')) return;
    var btn = item.querySelector('.acc__trigger'), panel = item.querySelector('.acc__panel');
    if (btn && panel) { btn.setAttribute('aria-expanded', 'true'); panel.dataset.open = 'true'; setTimeout(function () { item.scrollIntoView({ block: 'start' }); }, 60); }
  };
  openHashItem();
  window.addEventListener('hashchange', openHashItem);

  /* Reveal on scroll ----------------------------------------------------- */
  var reveals = document.querySelectorAll('.reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.dataset.seen = 'true'; });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.dataset.seen = 'true';
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    reveals.forEach(function (el) { io.observe(el); });
    // Anything already on screen at load is shown at rest, whatever the
    // viewport height; the observer only handles what scrolls in later.
    var vh = window.innerHeight;
    reveals.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) { el.dataset.seen = 'true'; io.unobserve(el); }
    });
  }

  /* Toast ---------------------------------------------------------------- */
  var toast = document.getElementById('toast');
  var toastTimer;
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.dataset.open = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.dataset.open = 'false'; }, 4000);
  }

  /* Basket — PLACEHOLDER.
     There is no store wired up yet, so every Add-to-basket control only
     increments a local counter and confirms. Replace the body of this
     handler with the real cart call when the shop goes live. */
  var count = 0;
  var counters = document.querySelectorAll('[data-basket-count]');
  document.querySelectorAll('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      count += 1;
      counters.forEach(function (c) { c.textContent = String(count); c.hidden = false; });
      say(btn.dataset.add + ' — added. (Checkout opens soon.)');
    });
  });

  /* Newsletter — front end only, no endpoint connected yet ---------------- */
  document.querySelectorAll('[data-signup]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var status = form.parentElement.querySelector('.form-status');
      if (!input || !input.value.trim()) return;
      if (status) {
        status.textContent = 'Thank you. Ten percent off your first order is on its way to your inbox.';
        status.dataset.state = 'ok';
      }
      form.reset();
    });
  });

  /* Product gallery ------------------------------------------------------ */
  document.querySelectorAll('.pdp__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('.pdp__gallery');
      var stage = gallery && gallery.querySelector('.pdp__stage img');
      var full = thumb.dataset.full;
      if (!stage || !full) return;
      stage.src = full;
      stage.alt = thumb.dataset.alt || stage.alt;
      gallery.querySelectorAll('.pdp__thumb').forEach(function (t) {
        t.setAttribute('aria-current', String(t === thumb));
      });
    });
  });

  /* Header shadow once the page has moved off the hero -------------------- */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () {
      header.style.borderBottomColor = window.scrollY > 8
        ? 'rgba(39, 22, 8, 0.14)' : 'rgba(39, 22, 8, 0.07)';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Current year in the footer ------------------------------------------- */
  document.querySelectorAll('[data-year]').forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });

  /* About page sub-nav: mark the section in view ---------------------- */
  var subnav = document.querySelector('.subnav');
  if (subnav) {
    var links = Array.prototype.slice.call(subnav.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    var spy = function () {
      var line = subnav.getBoundingClientRect().bottom + 24, current = null;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) current = i; });
      links.forEach(function (a, i) {
        if (i === current) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
    };
    window.addEventListener('scroll', spy, { passive: true });
    spy();
  }

  window.humdrumToast = say;
})();
